import type { StageCardDataStatus } from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import type { StageCardDisplayMode } from 'containers/user/critical-elements-monitoring/components/funnel-stage-card';
import type { ProspectAvailability } from 'containers/user/critical-elements-monitoring/helpers/get-prospect-availability';
import type { FunnelStageMetric } from 'containers/user/critical-elements-monitoring/critical-elements-monitoring.types';

const INQUIRY_RATE_STATUS: Record<
  ProspectAvailability,
  StageCardDataStatus | undefined
> = {
  active: undefined,
  unlockable: 'prospect-upsell',
  unavailable: 'metric-not-available',
};

export const getStageDataStatus = (
  stage: FunnelStageMetric,
  displayMode: StageCardDisplayMode,
  prospectAvailability: ProspectAvailability
): StageCardDataStatus | undefined => {
  if (stage.dataStatus) return stage.dataStatus;

  const isInquiryRate = stage.stageKey === 'inquiry' && displayMode === 'rate';

  return isInquiryRate ? INQUIRY_RATE_STATUS[prospectAvailability] : undefined;
};
